namespace Gordic.Vyp.VypPrefabs
{
    export function poplatekColumn(): GGridColumn<any> {
        return {
            name: "poplatek",
            caption: "jres:23900015", //RC 23900015 : Poplatek
            width: 80,
            format: "D2" 
        }
    }
    export function vahaColumn(): GGridColumn<any> {
        return {
            name: "vaha",
            caption: "jres:23900016", //RC 23900016 : Váha
            width: 80,
            format: "D3" 
        }
    }
    export function cenaColumn(): GGridColumn<any> {
        return {
            name: "cena",
            caption: "jres:23900017", //RC 23900017 : Cena
            width: 80,
            format: "D2"
        }
    }
    export function TridVypColumn(): GGridColumn<any> {
        return {
            name: "trid_vyp",
            caption: "xxxx", //RC 23900017 : Cena
            width: 80

        }
    }
    export function idDSOdesiltele(): GGridColumn<any> {
        return {
            name: "id_ds_odes",
            caption: "jres:23900018", //RC 23900018 : ID DS odesílatele
            width: 100,
        }
    }

    export function SekcePredplneniZasilek(): Gordic.Forms.FormSection[]
    {
        return Gin.Prefabs.preReturn(new Gordic.Forms
            .Form({ name: "RedistribucePrefabForm", tabLabel: "jres:23900042" }) //RC 23900042 : Předplnění
            .addSection()
            .addRow("jres:23900043" + ", " + "jres:23900044" + ", " + "jres:23900045") //RC 23900046 : Nové pod. číslo
            //.addRow("jres:23900043" + ", " + "jres:23900044" + ", " + "jres:23900045" + ", " + "jres:23900046") //RC 23900046 : Nové pod. číslo
            .addField("gstringbox", "w-3", { name: "text_pred" })
            .addField("gnumberbox", "w-3", { name: "pod_cislo" })
            .addField("gstringbox", "w-3", { name: "text_za" })
           // .addField("gcheck", "", { name: "novePodaciCislo" }) 
            .addRow("jres:23900015" + ", " + "jres:23900016") //RC 23900015 : Poplatek
            .addField("gnumberbox", "w-3", { name: "poplatek", decimals: 2, minValue: 0, maxValue : 999.9999  })
            .addField("gnumberbox", "w-3", { name: "vaha", decimals: 4, minValue: 0, maxValue: 99.9999  }))
            ;        
    }
}